// ============================================
// Path: /frontend/src/pages/RegisterPage.jsx
// Purpose: Registration page wrapper
// ============================================

import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { RegisterForm } from '../components/auth/RegisterForm';

export default function RegisterPage() {
  return (
    <div className="flex flex-col min-h-screen bg-muted/40">
      <Header />
      <main className="flex-grow flex items-center justify-center py-8">
        <RegisterForm />
      </main>
      <Footer />
    </div>
  );
}